import script from "./validateCommons.vue?vue&type=script&lang=js"
export * from "./validateCommons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__